import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { BankAccount } from 'src/features/billingEntityBankAccounts/utils/types';
import { BankAccountFormSchemaValues } from 'src/features/billingEntityBankAccounts/utils/formSchema';

const RESOURCE = '/customers/billing-entity-bank-account/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: BankAccountFormSchemaValues): Promise<BankAccount> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateBillingEntityBankAccount };
